import type { ComponentProps, ElementType } from "react";
import { cn } from "@/lib/cn";

type ButtonProps<T extends ElementType = "button"> = {
  as?: T;
  variant?: "default" | "danger";
  priority?: boolean;
} & Omit<ComponentProps<T>, "as">;

export const Button = <T extends ElementType = "button">({
  as,
  variant = "default",
  priority,
  className,
  ...props
}: ButtonProps<T>) => {
  const Component = as ?? "button";
  return (
    <Component
      className={cn(
        "min-h-11 cursor-pointer rounded border px-4 py-2 transition-all duration-300 disabled:cursor-default disabled:opacity-40 aria-disabled:cursor-default aria-disabled:opacity-40",
        priority
          ? "border-foreground bg-foreground font-bold text-background"
          : variant === "danger"
            ? "border-red-500 text-red-500"
            : "border-foreground",
        className,
      )}
      {...(props as ComponentProps<T>)}
    />
  );
};
